import React from "react";

import MentoryIcon from "../../atoms/icons/Mentory";
import Button from "../../atoms/button/button";

import { Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";

import { JobDetails } from "../../../interfaces/JobDetails";

import JobCard from "../job-card/jobCard";
import MeProtejoilustracion from "../../../../static/meprotejoilustracion.svg";	

import "./JobSuggestions.scss";

const MAIN_CLASS = "m-job-suggestions";

const headingBlockList = [
    BLOCKS.HEADING_1,
    BLOCKS.HEADING_2,
    BLOCKS.HEADING_3,
    BLOCKS.HEADING_4,
    BLOCKS.HEADING_5,
    BLOCKS.HEADING_6,
];
const renderHeadings = headingBlockList
    ?.map((type) => ({
        [type]: (_, children) => {
            return <h2 className="subtitle">{children}</h2>;
        },
    }))
    .reduce((a, b) => ({ ...a, ...b }), {});

const contentfulRenderOptions: Options = {
    renderNode: {
        [INLINES.HYPERLINK]: ({ data }, children) => (
            <a
                href={data.uri}
                target={"_blank"}
                rel={"noopener noreferrer"}
                style={{ color: "var(--color-magenta-white)" }}
                className="show-more protectme-link"
            >
                {children}
            </a>
        ),
        ...renderHeadings,
    },
    renderText: (text) =>
        text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
};

interface JobSuggestionsProps {
    mentoryText: string;
    protectmeText: string;
    recommendedJobs?: JobDetails[];
    onClickPostulate?: () => void;
}

const JobSuggestions = ({
    mentoryText,
    protectmeText,
    recommendedJobs = [],
    onClickPostulate,
}: JobSuggestionsProps) => {
    return (
        <div className={MAIN_CLASS}>
            <div className={`${MAIN_CLASS}__mentory`}>
                <MentoryIcon />

                <div className={`${MAIN_CLASS}__mentory__body`}>
                    {mentoryText &&
                        rawToReact(mentoryText, contentfulRenderOptions)}
                </div>
            </div>

            {recommendedJobs.length > 0 ? (
                <div className={`${MAIN_CLASS}__jobs-suggestions`}>
                    <h2 className="subtitle">Vacantes sugeridas</h2>
                    <div className={`${MAIN_CLASS}__jobs`}>
                        {recommendedJobs?.map((jobDetails) => {
                            return (
                                <JobCard
                                    key={jobDetails.referenceNumber}
                                    title={jobDetails.title}
                                    date={jobDetails?.date}
                                    company={jobDetails.company}
                                    city={jobDetails.city}
                                    referenceNumber={jobDetails.referenceNumber}
                                    url={jobDetails.url}
                                    salary={jobDetails.salary}
                                />
                            );
                        })}
                    </div>
                </div>
            ) : null}

            <div className={`${MAIN_CLASS}__protectme`}>
                <img
                    src={MeProtejoilustracion}
                    alt="Me Protejo"
                    className={`${MAIN_CLASS}__protectme__img`}
                />
                <p className={`${MAIN_CLASS}__protectme__text`}>
                    {protectmeText &&
                        rawToReact(protectmeText, contentfulRenderOptions)}
                </p>
            </div>

            <div className={`${MAIN_CLASS}__button-container`}>
                <Button
                    type={"button"}
                    classname={
                        "a-button__magenta_aceleradora big center btn-apply gtmVacanteClickButtonPostularme"
                    }
                    text={"Postularme"}
                    isDisabled={false}
                    onClickAction={onClickPostulate}
                />
            </div>
        </div>
    );
};

export default JobSuggestions;
